import { DocumentTitle } from 'components/DocumentTitle';
import { DetailsPage } from 'components/page/DetailsPage';
import {
    invalidateAssetType,
    useAssetType,
} from 'custom_hooks/data_hooks/asset/useAssetType';
import { AssetCategoryParameterDetails } from 'pages/Settings/AssetType/AssetCategoryParameterDetails';
import { AssetTypeDetails } from 'pages/Settings/AssetType/AssetTypeDetails';

export type AssetTypeDetailsPageProps = Readonly<{
    assetTypeId: number;
}>;

export function AssetTypeDetailsPage({ assetTypeId }: AssetTypeDetailsPageProps) {
    const { data: assetType, isLoading, error } = useAssetType(assetTypeId);

    const onUpdate = () => invalidateAssetType(assetTypeId);

    return (
        <DetailsPage
            error={error ? 'Unable to load asset type' : undefined}
            invalidURL={!assetType && !isLoading && !!error}
            isLoading={isLoading}
            fullHeight
            fullWidth
        >
            <DocumentTitle
                title={`Asset Type: ${assetType?.Name ?? assetType?.Code ?? ''}`}
            />
            {assetType && <AssetTypeDetails assetType={assetType} onUpdate={onUpdate} />}
            <AssetCategoryParameterDetails assetTypeId={assetTypeId} />
        </DetailsPage>
    );
}
